<template>
  <FullPageModal
    :isOpen="addDeviceModalOpen"
    :onCloseModal="closeModal"
    :headerText="t('modals.modal_device_add_title')">
    <AddDeviceForm @reset="closeModal" />
  </FullPageModal>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";
import FullPageModal from "../library/FullPageModal/FullPageModal.vue";
import AddDeviceForm from "../elements/AddDeviceForm/AddDeviceForm.vue";
import { useTranslation } from "i18next-vue";
import { useUISettingsStore } from "@/storeModules/uisettings/UISettingsStore";

const { t } = useTranslation();
const { addDeviceModalOpen } = storeToRefs(useUISettingsStore());
const { closeModal } = useUISettingsStore();
</script>
